export const adminParamsSelector = (state) => state.admin.params;
export const adminSelector = (state) => state.admin;
